var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_999",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6673 6.68336C35.0007 7.50002 33.3673 7.83169 31.6673 8.33336C29.799 6.22502 27.029 6.10836 24.3673 7.10502C21.7057 8.10169 19.9623 10.5384 20.0007 13.3334V15C14.5923 15.1384 9.77565 12.675 6.66732 8.33336C6.66732 8.33336 -0.302682 20.7217 13.334 26.6667C10.214 28.745 7.10232 30.1467 3.33398 30C8.84732 33.005 14.8557 34.0384 20.0573 32.5284C26.024 30.795 30.9273 26.3234 32.809 19.625C33.3703 17.5878 33.649 15.4831 33.6373 13.37C33.634 12.955 36.154 8.75002 36.6673 6.68169V6.68336Z",
    stroke: "#1DA1F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9a8ad8579b991381199dab8901809afb.svg";
export { ForwardRef as ReactComponent };